module.exports = __webpack_public_path__ + "static/img/doc.d284aa5d.png";